import { render, staticRenderFns } from "./OrgCard.vue?vue&type=template&id=5aec9d80&"
import script from "./OrgCard.vue?vue&type=script&lang=js&"
export * from "./OrgCard.vue?vue&type=script&lang=js&"
import style0 from "./OrgCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports